import { render, staticRenderFns } from "./EmployeeCalendarLayout.vue?vue&type=template&id=4852a5ca&scoped=true&"
import script from "./EmployeeCalendarLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeCalendarLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852a5ca",
  null
  
)

export default component.exports